// ---------------------------------------------------------------------------
// Avatar da pessoa logada: mostra a foto (ficha ou Google) ou as iniciais,
// sempre pelo mesmo hook useMinhaFoto. Tamanho quadrado e object-cover para
// nunca deformar. Usado na barra de cima, no menu ☰ e no perfil.
// ---------------------------------------------------------------------------
import { useMinhaFoto } from '@/hooks/useMinhaFoto';

interface AvatarPessoaProps {
  /** Lado do círculo, em px. */
  tamanho?: number;
  /** Classes extras no elemento (ex.: ring/borda). */
  className?: string;
  /** Classes do texto das iniciais (ex.: tamanho da fonte). */
  textoClassName?: string;
}

export default function AvatarPessoa({
  tamanho = 40,
  className = '',
  textoClassName = '',
}: AvatarPessoaProps) {
  const { logado, fotoUrl, iniciais, nome } = useMinhaFoto();
  const estilo = { width: tamanho, height: tamanho };

  if (fotoUrl) {
    return (
      <img
        src={fotoUrl}
        alt={nome || 'Foto de perfil'}
        style={estilo}
        className={`shrink-0 rounded-full object-cover object-center ${className}`}
      />
    );
  }

  if (logado && iniciais) {
    return (
      <span
        style={estilo}
        className={`flex shrink-0 items-center justify-center rounded-full bg-primary-500 font-extrabold text-white ${textoClassName} ${className}`}
      >
        {iniciais}
      </span>
    );
  }

  return (
    <span
      style={estilo}
      className={`flex shrink-0 items-center justify-center rounded-full bg-primary-500 text-white ${className}`}
    >
      <i className="ri-user-3-line" style={{ fontSize: Math.round(tamanho * 0.55) }} aria-hidden />
    </span>
  );
}